import React, { useEffect } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CRow,
  CFormSelect,
  CLink,
  CCardText,
} from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import { getMaster } from "src/modules/subscriptionAdmin/action";
import validator from "validator";
// List of countries
var isoCountryCurrency = require("iso-country-currency");
import CIcon from "@coreui/icons-react";
import { cilPlus, cilTrash } from "@coreui/icons";
import { createSubscription } from "src/modules/subscriptionAdmin/action";
import { Button } from "@coreui/coreui";

// handle change frm drop down

class CreatePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subFeature: "",
      country: "",
      company: "",
      planTitle: "",
      planDuration: "",
      planPrice: "",
      attempts: "",
      currency: "",
      featureInputs: [{ index: Math.random(), feature: "", attempts: "", subFeatures: [] }],
      //paymentInput: [{ index: Math.random(), type: "oneTime", price: "", period: "", currency: "USD", selectedType: "" }],
      // paymentInput: [
      //   { index: Math.random(), amount: "", currency: "", isRecurring: "", interval: "", interval_count: "", selectedType: "", type: "" },
      // ],
      paymentInput: [{ index: Math.random(), amount: "", currency: "", isRecurring: true, type: "Recurring", intervalCount: "", billingPeriod: "" }],
      paymentRowCount: 1,
      companies: [],
      features: [],
      subFeatures: [],
      companyCode: "",
      anotherPayment: false,
      feature: "",
      planTag: "",
      planDescription: "",
      currentRecIndex: "",
      currentOneIndex: "",
      loading: false,
      isOneTimePurchase: false,
      singlePrice: false,
      trialPeriod: 0,
      trialPeriodVisible: true,
    };
  }

  onChange = (e) => {
    this.setState({});
  };

  componentDidUpdate(prevProps) {
    const { companies, features, subscription, createError, subFeatures } = this.props;
    const {
      companies: prevCompanies,
      features: prevFeatures,
      subscription: prevSubsubscription,
      createError: prevCreateError,
      subFeatures: prevSubFeatures,
    } = prevProps;
    const companyData = [];
    const featureData = [];
    const subFeatureData = [];

    // companies
    if (companies && companies !== prevCompanies) {
      const { data } = companies;
      data && data.companies
        ? data.companies.map((company) =>
          companyData.push({
            value: company._id,
            label: company.companyName + "(" + company.country + ")",
            code: company.companyCode,
            countryCode: company.countryCode,
            country: company.country,
          })
        )
        : [];

      this.setState({
        companies: companyData,
      });
    }

    // features
    if (features && features !== prevFeatures) {
      const { data } = features;
      // features
      data && data.features
        ? data.features.map((feature) =>
          featureData.push({
            value: feature._id,
            label: feature.name,
          })
        )
        : [];

      this.setState({
        features: featureData,
      });
    }

    // features
    if (subFeatures && subFeatures !== prevSubFeatures) {
      const { data } = subFeatures;
      // features
      data && data.subFeatures
        ? data.subFeatures.map((subFeature) =>
          subFeatureData.push({
            value: subFeature._id,
            label: subFeature.name,
          })
        )
        : [];

      this.setState({
        subFeatures: subFeatureData,
      });
    }

    // plan createion
    if (subscription && subscription !== prevSubsubscription) {
      this.setState({
        loading: false,
      });
      NotificationManager.success("Plan Created");
      //setTimeout(function () {
      this.props.history.push("/admin/subscription/list");
      //}, 100);
    }

    // create error
    if (createError && createError !== prevCreateError) {
      this.setState({ loading: false });
      NotificationManager.error(createError.message);
    }
  }
  

  componentDidMount() {
    this.props.getMaster();
  }

  // handle feature change
  handleFeatureChange = (index, event, key, subFeatureIndexs = "") => {
    if (event !== "" || event !== null) {
      const values = [...this.state.featureInputs];
      if (key === "attempts") {
        this.setState({
          attempts: {
            ...this.state.attempts,
            [index]: event.target.value,
          },
        });
        values[index].attempts = event.target.value;
      } else if (key === "feature") {
        const featureValue = event.value;
        this.setState({
          feature: {
            ...this.state.feature,
            [index]: { label: event.label, value: event.value },
          },
        });
        values[index].feature = event.value;
      } else if (key === "subFeature") {
        const subFeatureIndex = subFeatureIndexs; // Assuming you have a subFeatureIndex available
        const subFeatureValue = event.value;
        values[index].subFeatures[subFeatureIndex] = subFeatureValue;
      }
      this.setState({ featureInputs: values });
    }
  };

  // handle payment change
  handlePaymentChange = (index, event, key) => {
    if (event !== "" || event !== null) {
      const { value } = event.target;
      const { paymentInput, currency, planDuration } = this.state;
      const updatedPaymentInput = [...paymentInput];
      updatedPaymentInput[index].currency = currency;
      updatedPaymentInput[index][key] = value;
      if (key === "billingPeriod") {
        //const intervalCount = planDuration / value;
        //updatedPaymentInput[index].intervalCount = intervalCount;
        updatedPaymentInput[index].intervalCount = value;
      }
      this.setState({
        paymentInput: updatedPaymentInput,
      });
    }
  };

  // add payment row
  addPaymentRow = (type) => {
    const { paymentInput, paymentRowCount } = this.state;
    if (paymentRowCount < 2) {
      let newPaymentInput = "";
      if (type === "Upfront") {
        newPaymentInput = [...paymentInput, { index: Math.random(), amount: "", currency: "", isRecurring: false, type: "Upfront" }];
      } else {
        newPaymentInput = [...paymentInput, { index: Math.random(), amount: "", currency: "", isRecurring: true, type: "Recurring" }];
      }
      this.setState({ paymentInput: newPaymentInput, paymentRowCount: paymentRowCount + 1 });
    } else {
      NotificationManager.error("You can only have up to 2 payment");
    }
  };

  // delete payment row
  // deletePaymentRow = (item, index) => {
  //   const { paymentInput, paymentRowCount } = this.state;
  //   if (paymentRowCount > 1) {
  //     const newPaymentInput = paymentInput.slice(0, -1);
  //     this.setState({ paymentInput: newPaymentInput, paymentRowCount: paymentRowCount - 1 });
  //   } else {
  //     NotificationManager.error("You must have at least 1 payment row");
  //   }
  // };
  deletePaymentRow = (item, index, type) => {
    const { paymentInput, paymentRowCount } = this.state;
    const updatedPaymentInput = [...paymentInput];

    // Find the index of the row to delete based on type
    const rowIndexToDelete = updatedPaymentInput.findIndex((row) => row.type === type);

    if (rowIndexToDelete > -1) {
      if (paymentRowCount > 1) {
        updatedPaymentInput.splice(rowIndexToDelete, 1); // Remove the row at the found index
        this.setState({ paymentInput: updatedPaymentInput, paymentRowCount: paymentRowCount - 1 });
      } else {
        NotificationManager.error("You must have at least one payment row");
      }
    } else {
      NotificationManager.error(`No ${type} row found.`);
    }
  };

  // add feature row
  addFeatureRow = () => {
    const values = [...this.state.featureInputs];
    values.push({ index: Math.random(), feature: "", attempts: "", subFeatures: [] });
    this.setState({ featureInputs: values });
  };

  // delete feature row
  deleteFeatureRow = (index) => {
    const values = [...this.state.featureInputs];
    values.splice(index, 1);
    this.setState({ featureInputs: values });
  };

  addSubFeatureRow = (featureIndex) => {
    this.setState((prevState) => {
      const { featureInputs } = prevState;
      const updatedFeatureInputs = featureInputs.map((input, index) => {
        if (featureIndex === index) {
          return {
            ...input,
            //subFeatures: [...input.subFeatures, { subFeature: [] }],
            subFeatures: [...input.subFeatures, ""],
          };
        }
        return input;
      });
      //console.log(updatedFeatureInputs);
      return { featureInputs: updatedFeatureInputs };
    });
  };

  // delete sub feature row
  deleteSubFeatureRow = (featureIndex, subFeatureIndex) => {
    this.setState((prevState) => {
      const { featureInputs } = prevState;
      const updatedFeatureInputs = featureInputs.map((input, index) => {
        if (index === featureIndex) {
          const updatedSubFeatures = input.subFeatures.filter((subFeature, idx) => idx !== subFeatureIndex);
          return {
            ...input,
            subFeatures: updatedSubFeatures,
          };
        }
        return input;
      });

      return { featureInputs: updatedFeatureInputs };
    });
  };

  hasDuplicateEntry = (array) => {
    const uniqueSet = new Set(array);
    return uniqueSet.size !== array.length;
  };

  // handle submit form
  handleSubmit = (event) => {
    event.preventDefault();
    //props.createSubscription({ postData });

    const {
      country,
      company,
      companyCode,
      planTitle,
      planDuration,
      tag,
      paymentInput,
      featureInputs,
      planTag,
      planDescription,
      isOneTimePurchase,
      trialPeriod,
    } = this.state;

    if (company == "" || company == null) {
      NotificationManager.error("Choose a company");
      return false;
    }

    if (planTitle == "" || planTitle == null) {
      NotificationManager.error("Plan title is required");
      return false;
    }

    if (planDuration == "" || planDuration == null) {
      NotificationManager.error("Duration is required");
      return false;
    }

    if (planDescription == "" || planDescription == null) {
      NotificationManager.error("Plan detail is required");
      return false;
    }

    // feature validation
    let invalidAttempt = false;
    let invalidFeature = false;
    featureInputs.forEach((item) => {
      if (item.feature === "") {
        invalidFeature = true;
      }
      if (item.attempts <= 0) {
        invalidAttempt = true;
      }
    });

    if (invalidFeature) {
      NotificationManager.error("Feature is required");
      return false;
    }
    if (invalidAttempt) {
      NotificationManager.error("Invalid Attempt Count");
      return false;
    }

    //price validation
    let isValid = true;
    let invalidAmount = false;
    let RecurringNotAllowed = false;
    paymentInput.forEach((item) => {
      if (item.type === "Recurring" && (item.billingPeriod == undefined || item.billingPeriod == "")) {
        isValid = false;
      }
      if (item.currency == "" || item.amount == "") {
        console.log("two");
        isValid = false;
      }
      // chek the invalid amount
      if (item.amount && item.amount <= 0) {
        invalidAmount = true;
      }
      // check if plan duration is one and recurring is true
      if (planDuration == 1 && item.type === "Recurring") {
        RecurringNotAllowed = true;
      }
    });

    if (!isValid) {
      NotificationManager.error("Payment field is required");
      return false;
    }

    if (invalidAmount) {
      NotificationManager.error("Invalid Price");
      return false;
    }

    if (RecurringNotAllowed) {
      NotificationManager.error("Recurring is not possible with one month");
      return false;
    }

    // Check for duplicate feature entries
    const featureValues = featureInputs.map((input) => input.feature);
    const hasDuplicateFeature = this.hasDuplicateEntry(featureValues);
    if (hasDuplicateFeature) {
      // Handle duplicate feature entries
      NotificationManager.error("Duplicate feature entries");
      return;
    }

    // Check for duplicate sub-feature entries
    // Check for duplicate sub-feature entries
    let hasDuplicateSubFeature = false;
    featureInputs.forEach((input) => {
      const subFeatureValues = input.subFeatures;
      const hasDuplicate = this.hasDuplicateEntry(subFeatureValues);
      if (hasDuplicate) {
        hasDuplicateSubFeature = true;
        return;
      }
    });

    if (hasDuplicateSubFeature) {
      // Handle duplicate sub-feature entries
      NotificationManager.error("Duplicate sub-feature entries");
      return;
    }

    if (parseInt(planDuration) * 30 < parseInt(trialPeriod)) {
      NotificationManager.error("Trial period must be shorter than plan duration.");
      return;
    }
    // if(this.planTag !==""){
    //   NotificationManager.error("Tag Name is required")
    //   return ;
    // }

    const postData = {
      title: planTitle,
      duration: planDuration,
      servicesOffered: featureInputs,
      prices: paymentInput,
      company: company.value,
      description: planDescription,
      tag: planTag,
      isOneTimePurchase: isOneTimePurchase,
      planTrialDays: trialPeriod,
    };

    console.log("postdata", postData);

    this.props.createSubscription({ postData });
    this.setState({
      loading: true,
    });
  };

  cancelForm = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };

  // handle company change
  handleCompanyChange = (data) => {
    const currency = isoCountryCurrency.getParamByParam("countryName", data.country, "currency");
    this.setState({
      currency: currency,
      company: { label: data.label, value: data.value },
      companyCode: data.code,
      country: data.country,
    });
    // console.log(e.target.value);
  };

  // handle duration change
  handleDurationChange = (value) => {
    this.setState({
      planDuration: value,
    });
  };

  handleisOneTimePurchase = () => {
    this.setState({ isOneTimePurchase: !this.state.isOneTimePurchase });
  };

  render() {
    const {
      planTitle,
      featureInputs,
      company,
      currency,
      companies,
      companyCode,
      features,
      feature,
      subFeature,
      subFeatures,
      paymentInput,
      currentRecIndex,
      currentOneIndex,
      planTag,
      planDescription,
      planDuration,
      loading,
      isOneTimePurchase,
      singlePrice,
      trialPeriodVisible,
    } = this.state;
    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>Create Plan</strong>
            </CCardHeader>
            <CCardBody>
              <CForm onSubmit={this.handleSubmit}>
                <CRow>
                  <h5 className="form-group-heading">General</h5>
                  <CCol md={6}>
                    <div className="mb-3">
                      <CFormLabel>Company</CFormLabel>
                      <span className="required"> *</span>
                      <Select value={company} onChange={this.handleCompanyChange} options={companies} placeholder="Select company" />
                    </div>
                    <div className="mb-3">
                      <CFormLabel htmlFor="exampleFormControlInput1">Plan Duration</CFormLabel>
                      <span className="required"> *</span>
                      <CFormSelect
                        onChange={(e) => this.handleDurationChange(e.target.value)}
                        aria-label="Default select example"
                        value={planDuration}
                      >
                        <option value="">Select plan duration</option>
                        <option value="1">1 Month</option>
                        <option value="3">3 Months</option>
                        <option value="6">6 Months</option>
                        <option value="12">12 Months</option>
                        <option value="24">24 Months</option>
                      </CFormSelect>
                    </div>
                  </CCol>
                  <CCol md={6}>
                    <div className="mb-3">
                      <CFormLabel htmlFor="exampleFormControlInput1">Plan Title</CFormLabel>
                      <span className="required"> *</span>
                      <CFormInput
                        type="text"
                        id="exampleFormControlInput1"
                        placeholder="Enter plan title"
                        onChange={(e) => this.setState({ planTitle: e.target.value })}
                        value={planTitle}
                      />
                    </div>
                    <div className="mb-3">
                      <CFormLabel htmlFor="exampleFormControlInput1">Tag Name</CFormLabel>
                      <span className="required"> *</span>
                      <CFormInput
                        maxlength="15"
                        type="text"
                        value={planTag}
                        placeholder="Tag name"
                        onChange={(e) => this.setState({ planTag: e.target.value })}
                      />
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md={6}>
                    <div className="mb-3">
                      <CFormLabel htmlFor="exampleFormControlInput1">Plan Details</CFormLabel>
                      <span className="required"> * (max 300 characters)</span>
                      <CFormTextarea
                        maxlength="300"
                        type="text"
                        value={planDescription}
                        placeholder="Plan Details"
                        onChange={(e) => this.setState({ planDescription: e.target.value })}
                      />
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md={12}>
                    <CFormLabel style={{ color: "#999", fontSize: "17px" }} htmlFor="exampleFormControlTextarea1">
                      <h5 className="form-group-heading">Features</h5>
                    </CFormLabel>
                    {featureInputs &&
                      featureInputs
                        .filter((item, idx) => idx < 5)
                        .map((item, index) => {
                          let featureName = `feature-${index}`,
                            attempts = `attempts-${index}`;
                          // Check if feature and attempts are filled for the row
                          const isFeatureFilled = featureInputs[index].feature !== "";
                          const isAttemptsFilled = featureInputs[index].attempts !== "";
                          return (
                            <div className="mb-3" key={index}>
                              <CRow>
                                <CCol md={4}>
                                  <CFormLabel htmlFor="exampleFormControlTextarea1">Features</CFormLabel>
                                  <Select
                                    //value={feature}
                                    onChange={(data) => this.handleFeatureChange(index, data, "feature")}
                                    options={features}
                                    placeholder="Select Feature"
                                    data-id={index}
                                    id={featureName}
                                    name="feature"
                                    value={feature[index]}
                                  />
                                  {/* <a onClick={() => this.addSubFeatureRow(index)} className="custom_link mt-2">
                                    <CIcon icon={cilPlus} />
                                  </a> */}
                                  {isFeatureFilled && isAttemptsFilled && (
                                    <a
                                      style={{ alignItems: "center", textDecoration: "none" }}
                                      onClick={() => this.addSubFeatureRow(index)}
                                      className="custom_link mt-2"
                                    >
                                      <CIcon icon={cilPlus} /> <CCardText style={{ marginLeft: "6px" }}>Add sub feature</CCardText>
                                    </a>
                                  )}
                                  {featureInputs[index] &&
                                    featureInputs[index].subFeatures &&
                                    featureInputs[index].subFeatures.map((items, indexs) => {
                                      return (
                                        <CRow>
                                          <CCol md={10}>
                                            <CFormLabel className="mt-4" htmlFor="exampleFormControlTextarea1">
                                              Sub Features
                                            </CFormLabel>
                                            <Select
                                              //value={feature}
                                              onChange={(data) => this.handleFeatureChange(index, data, "subFeature", indexs)}
                                              options={subFeatures}
                                              placeholder="Select"
                                              data-id={indexs}
                                              id={featureName}
                                              name="subFeature"
                                              value={subFeature[indexs]}
                                            />
                                          </CCol>
                                          <CCol md={2}>
                                            <CFormLabel className="mt-4" style={{ visibility: "hidden" }} htmlFor="exampleFormControlTextarea1">
                                              Sub
                                            </CFormLabel>
                                            <a onClick={() => this.deleteSubFeatureRow(index, indexs)} className="custom_link mt-2">
                                              <CIcon icon={cilTrash} />
                                            </a>
                                          </CCol>
                                        </CRow>
                                      );
                                    })}
                                </CCol>
                                <CCol md={4}>
                                  <CFormLabel htmlFor="exampleFormControlTextarea1">Attempt</CFormLabel>
                                  <CFormInput
                                    placeholder="Attempts"
                                    data-id={index}
                                    id={attempts}
                                    name="attempts"
                                    type="number"
                                    min={1}
                                    //value={selectedCount[index]}
                                    onChange={(data) => this.handleFeatureChange(index, data, "attempts")}
                                  />
                                </CCol>
                                <CCol md={4}>
                                  <CFormLabel style={{ visibility: "hidden" }} htmlFor="exampleFormControlTextarea1">
                                    {index === 0 ? "Add" : " "}
                                  </CFormLabel>
                                  {index === 0 ? (
                                    <div>
                                      <CButton onClick={this.addFeatureRow} style={{ width: "100%" }}>
                                        <CCardText>Add Feature</CCardText>
                                      </CButton>
                                      {/* <CIcon onClick={this.addFeatureRow} style={{ cursor: "pointer" }} icon={cilPlus} size="lg" /> */}
                                    </div>
                                  ) : (
                                    <div className="mt-2">
                                      <CButton onClick={() => this.deleteFeatureRow(index)} style={{ width: "100%" }}>
                                        <CCardText>Delete Feature</CCardText>
                                      </CButton>
                                    </div>
                                  )}
                                </CCol>
                              </CRow>
                            </div>
                          );
                        })}
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md={12}>
                    <CFormLabel style={{ color: "#999", fontSize: "17px" }} htmlFor="exampleFormControlTextarea1">
                      <h5 className="form-group-heading">Price</h5>
                    </CFormLabel>
                    {paymentInput &&
                      paymentInput
                        .filter((item, idx) => idx < 2)
                        .map((item, index) => {
                          return (
                            <div className="mb-3">
                              <CRow>
                                <CCol md={item.type === "Upfront" ? 2 : 2}>
                                  <CFormLabel htmlFor="exampleFormControlTextarea1">Currency</CFormLabel>
                                  <CFormInput type="text" value={currency} placeholder="SGD" />
                                </CCol>
                                <CCol md={item.type === "Upfront" ? 2 : 2}>
                                  <CFormLabel htmlFor="exampleFormControlTextarea1">Amount</CFormLabel>
                                  <CFormInput
                                    type="number"
                                    id="exampleFormControlInput1"
                                    placeholder="10"
                                    min={1}
                                    onChange={(data) => this.handlePaymentChange(index, data, "amount")}
                                  />
                                </CCol>
                                <CCol md={item.type === "Upfront" ? 2 : 2}>
                                  <CFormLabel htmlFor="exampleFormControlTextarea1">Type</CFormLabel>
                                  <div>
                                    {item.type === "Upfront" && (
                                      <CFormInput style={{ backgroundColor: "#eee" }} readOnly type="text" value="Upfront" />
                                    )}
                                    {item.type === "Recurring" && (
                                      <CFormInput style={{ backgroundColor: "#eee" }} readOnly type="text" value="Recurring" />
                                    )}
                                  </div>
                                  {/* </div> */}
                                </CCol>
                                {/* {item.type === "Upfront" && <CCol md={3}></CCol>} */}
                                {item.type === "Recurring" && (
                                  <CCol md={3}>
                                    <CFormLabel htmlFor="exampleFormControlTextarea1">Billing Period</CFormLabel>
                                    <CFormSelect
                                      onChange={(data) => this.handlePaymentChange(index, data, "billingPeriod")}
                                      aria-label="Default select example"
                                    //value={planDuration}
                                    >
                                      <option value="">Billing Period</option>
                                      {planDuration && planDuration == 1 && <option value="1">1 Month</option>}
                                      {planDuration && planDuration == 3 && (
                                        <>
                                          <option value="1">1 Month</option>
                                        </>
                                      )}
                                      {planDuration && planDuration == 6 && (
                                        <>
                                          <option value="1">1 Month</option>
                                          <option value="3">3 Months</option>
                                        </>
                                      )}
                                      {planDuration && (planDuration == 12 || planDuration == 24) && (
                                        <>
                                          <option value="1">1 Month</option>
                                          <option value="3">3 Months</option>
                                          <option value="6">6 Months</option>
                                        </>
                                      )}
                                    </CFormSelect>
                                  </CCol>
                                )}
                                {/* {item.type === "Upfront" && <CCol md={2}></CCol>} */}
                                {item.type === "Recurring" && (
                                  <CCol md={2}>
                                    <div className="mb-3">
                                      <CFormLabel htmlFor="exampleFormControlInput1">
                                        Trial Period <span style={{ fontSize: "14px" }}>(days)</span>
                                      </CFormLabel>
                                      <CFormInput
                                        type="number"
                                        id="exampleFormControlInput1"
                                        placeholder="if any in days"
                                        min={1}
                                        onChange={(data) => this.setState({ trialPeriod: data.target.value })}
                                      />
                                    </div>
                                  </CCol>
                                )}
                                <CCol md={item.type === "Upfront" ? 1 : 1}>
                                  <CFormLabel style={{ visibility: "hidden" }} htmlFor="exampleFormControlTextarea1">
                                    Add
                                  </CFormLabel>
                                  <div style={{ display: "flex" }}>
                                    {item.type === "Recurring" && paymentInput.length === 1 && (
                                      <a onClick={() => this.addPaymentRow("Upfront")} style={{ marginRight: "5px" }} className="custom_link mt-2">
                                        <CIcon icon={cilPlus} />
                                        {item.length}
                                      </a>
                                    )}
                                    {item.type === "Upfront" && paymentInput.length === 1 && (
                                      <a onClick={() => this.addPaymentRow("Recurring")} style={{ marginRight: "5px" }} className="custom_link mt-2">
                                        <CIcon icon={cilPlus} />
                                        {item.length}
                                      </a>
                                    )}

                                    {item.type === "Recurring" && (
                                      <a onClick={() => this.deletePaymentRow(item, index, "Recurring")} className="custom_link mt-2">
                                        <CIcon icon={cilTrash} />
                                      </a>
                                    )}
                                    {item.type === "Upfront" && (
                                      <a onClick={() => this.deletePaymentRow(item, index, "Upfront")} className="custom_link mt-2">
                                        <CIcon icon={cilTrash} />
                                      </a>
                                    )}
                                  </div>
                                  {/* {index === 0 ? (
                                    <div>
                                      {item.type !== "Upfront" && (
                                        <CButton onClick={this.addPaymentRow} style={{ width: "100%" }}>
                                          Add Upfront
                                        </CButton>
                                      )}
                                    </div>
                                  ) : (
                                    <div>
                                      <CButton onClick={this.deletePaymentRow} style={{ width: "100%" }}>
                                        Delete Upfront
                                      </CButton>
                                    </div>
                                  )} */}
                                </CCol>
                              </CRow>
                            </div>
                          );
                        })}
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md={6}>
                    <CRow>
                      <CCol md={6}>
                        <div className="form-check"></div>
                        <CFormLabel htmlFor="exampleFormControlInput1">
                          Is this one time purchase ?<span className="required">*</span>
                        </CFormLabel>
                      </CCol>
                      <CCol md={3}>
                        <div className="form-check"></div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="YES"
                            id="flexCheckDefault"
                            name="isOneTimePurchase"
                            onChange={this.handleisOneTimePurchase}
                            checked={isOneTimePurchase ? true : false}
                          />
                          <label className="form-check-label" for="flexCheckDefault">
                            YES
                          </label>
                        </div>
                      </CCol>
                      <CCol md={3}>
                        <div className="form-check"></div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            value="NO"
                            id="flexCheckDefault"
                            name="isOneTimePurchase"
                            onChange={this.handleisOneTimePurchase}
                            checked={!isOneTimePurchase ? true : false}
                          />
                          <label className="form-check-label" for="flexCheckDefault">
                            NO
                          </label>
                        </div>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md={6}>
                    <div className="mb-3 text-center mt-4">
                      {!loading && (
                        <CButton type="submit" color="primary" className="w-100">
                          Create Plan
                        </CButton>
                      )}
                      {loading && (
                        <button
                          type="button"
                          style={{
                            width: "100%",
                            backgroundColor: "#eee",
                            border: "#eee",
                            padding: 10,
                            color: "#000",
                            borderRadius: 10,
                          }}
                        >
                          Please Wait...
                        </button>
                      )}
                    </div>
                  </CCol>
                  <CCol md={6}>
                    <div className="mb-3 text-center mt-4">
                      <CButton type="submit" color="secondary" className="w-100" onClick={this.cancelForm}>
                        Cancel
                      </CButton>
                    </div>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.subscriptionAdmin,
  companies: state.subscriptionAdmin.companies,
  features: state.subscriptionAdmin.features,
  subFeatures: state.subscriptionAdmin.subFeatures,
  subscription: state.subscriptionAdmin.subscription,
  createError: state.subscriptionAdmin.createError,
});
export default connect(mapStateToProps, {
  getMaster,
  createSubscription,
})(CreatePlan);
